<template>
	<section id="losing--grid" class="losing--gif--container">
		<div
			class="losing_img"
			:class="{
				'losing-image-kids': gameMode === 'kids',
				'losing-image-adults': gameMode === 'adults',
			}"
		></div>
	</section>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'losingPage',
	props: {
		className: [String, Object],
		losingImage: [String, Object],
	},
	computed: {
		...mapState(['gameMode']),
	},
};
</script>
